import React from "react";
import SvgIcon from "../SvgIcon";

class DropdownIcons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMenu: false,
      selector: null,
      closed: false,
    };
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if (this.node && !this.node.contains(e.target) && this.state.showMenu) {
      //this is to close the modal clicking outside
      const tagName = e.target.tagName;
      if (tagName !== "SUMMARY" && tagName !== "SPAN" && tagName !== "IMG") {
        this.setState({ showMenu: false });
      }
    }
  }

  toggleMenu(e) {
    e?.preventDefault();
    if (this.state.showMenu) {
      document.removeEventListener("mousedown", this.handleClick, false);
    } else {
      document.addEventListener("mousedown", this.handleClick, false);
    }
    this.setState({ showMenu: !this.state.showMenu });
  }

  render() {
    const { title, items, action } = this.props;
    return (
      <details role="list" open>
        <summary
          onClick={this.toggleMenu}
          aria-haspopup="listbox"
          className="secondary"
        >
          <span>
            {!this.state.selector
              ? title
              : items.find((i) => i.id === this.state.selector).title}
          </span>
          <SvgIcon
            src={`/img/svg/angle-${this.state.showMenu ? "up" : "down"}.svg`}
            alt="Sort"
          />
        </summary>
        <ul
          ref={(node) => (this.node = node)}
          role="listbox"
          className={this.state.showMenu ? "opened" : ""}
        >
          {items.map(({ title, src, alt, id }, i) => (
            <li
              key={i}
              onClick={() => {
                action(id);
                this.setState({ selector: id });
                this.toggleMenu();
              }}
            >
              <div>
                <SvgIcon
                  key={i}
                  alt={alt}
                  src={`/img/new-icons/${
                    this.state.selector === id ? "" : "un"
                  }checked-square.svg`}
                  noFilterOnLight={this.state.selector === id}
                />
                {title}
              </div>
            </li>
          ))}
        </ul>
      </details>
    );
  }
}

export default DropdownIcons;
